const H5PDragText = (attempt, parameters = {}) => {
	parameters = JSON.parse(parameters) || {};
	const answers = JSON.parse(attempt.h5p_response.answer) || [];

	let response = parameters.textField || '';
	let answerIndex = 0;
	let areAnswersHidden = true;

	const regex = /\*(.*?)\*/g;

	const extractSolutionData = (solution) => {
		let cleanedSolution = solution;
		let tip = cleanedSolution.match(/(:([^\\*]+))/g);
		let correctFeedback = cleanedSolution.match(/(\\\+([^\\*:]+))/g);
		let incorrectFeedback = cleanedSolution.match(/(\\\-([^\\*:]+))/g);

		if (tip) {
			cleanedSolution = cleanedSolution.replace(tip, '');
		}
		if (correctFeedback) {
			cleanedSolution = cleanedSolution.replace(correctFeedback, '');
		}
		if (incorrectFeedback) {
			cleanedSolution = cleanedSolution.replace(incorrectFeedback, '');
		}

		return {
			solution: cleanedSolution.trim(),
			hasSolution: cleanedSolution.length > 0
		};
	};

	const generateAnswerBox = (userAnswer, solutionData) => {
		if (userAnswer.correct) {
			return `<span class="box correct" tabindex="0">
                        <i class="icon correct-icon pb-heroicons pb-heroicons-solid_check"></i>
                        ${userAnswer.answer}
                    </span>`;
		}

		let output = `<span class="box incorrect" tabindex="0">
                        <i class="icon incorrect-icon pb-heroicons pb-heroicons-solid_x-mark"></i>
                        ${userAnswer.answer}
                    </span>`;

		if (solutionData.hasSolution) {
			output += `<span class="box correct-answer">${solutionData.solution}</span>`;
		}

		return output;
	};

	response = response.replace(/\n/g, '<br>').replace(regex, (_, solution) => {
		const userAnswer = answers[answerIndex++] || { answer: '', correct: false };
		const solutionData = extractSolutionData(solution);
		if (solutionData.hasSolution) {
			areAnswersHidden = false;
		}
		return generateAnswerBox(userAnswer, solutionData);
	});

	return `
        <div class="h5p-drag-text">
            <div class="question">${response}</div>
            <div class="explanation">
                ${!areAnswersHidden ? `<div class="box correct-answer">Correct Answer</div>` : ''}
                <div class="box correct">
                    <i class="icon correct-icon pb-heroicons pb-heroicons-solid_check"></i>
                    User's correct answer
                </div>
                <div class="box incorrect">
                    <i class="icon incorrect-icon pb-heroicons pb-heroicons-solid_x-mark"></i>
                    User's incorrect answer
                </div>
            </div>
        </div>
    `;
};

export default H5PDragText;
